module.exports = __webpack_public_path__ + "static/media/CHANNEL_PARTNER_AGREEMENT.d2e7ac04.pdf";